import { DatePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Modal,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { assignStockToCityData, stockOutSendType, updateStockInDataApi } from "src/api/commonapi";
import { fetchallcitylist } from "src/utils/common";
import { notification } from "src/utils/messages";
import { useStockUser, useRealUser } from "../CityStockReport/CityStockContext";

export default function AssignProductModal({
  assignProductModal,
  setAssignProductModal,
  toggleAssignProductModal,
  rowData,
  handleGetProducts,
  modalType
}) {
  const user = useStockUser();
  const realUser = useRealUser();

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2
  };

  const [cityList, setClityList] = useState([]);
  const [sendTypeList, setSendTypeList] = useState([]);
  const [loader, setLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [assignData, setAssignData] = useState({
    city_id: modalType === "Edit" ? rowData?.city_id : (rowData?.city_id || ""),
    p_qty: modalType === "Edit" ? rowData?.qty : "",
    q_c_name: modalType === "Edit" ? rowData?.q_c_name : "",
    p_name: rowData?.p_name,
    p_id: rowData?.p_id,
    s_type_id: modalType === "Edit" ? rowData?.s_type_id : "",
    courier_price: modalType === "Edit" ? rowData?.courier_price : "",
    date:
      modalType === "Edit"
        ? rowData?.date
          ? moment(rowData.date, "DD-MM-YYYY").toDate() // 👈 convert to Date
          : new Date()
        : new Date(),
    p_city_price: rowData.p_city_price,
    assign_to:
      modalType === "Edit"
        ? rowData.city_id !== 0
          ? 1
          : 2
        : user?.u_type === 0 || (user?.u_type === 2 && user?.p_user_id === 1)
          ? 1
          : 2,
    assign_name: modalType === "Edit" ? rowData?.assign_name : "",
    city_name: rowData?.city_name || ""
  });

  const resetFormData = () => {
    setAssignData({
      city_id: rowData?.city_id || "",
      p_qty: "",
      q_c_name: "",
      p_name: rowData?.p_name,
      p_id: rowData?.p_id,
      s_type_id: "",
      courier_price: "",
      date: new Date(),
      p_city_price: rowData.p_city_price,
      assign_to: user?.u_type === 0 || (user?.u_type === 2 && user?.p_user_id === 1) ? 1 : 2,
      assign_name: "",
      city_name: rowData?.city_name || "",
      receipt: "",
      dispatch_form: ""
    });
  };

  const assignOptions = [
    { value: 1, label: "Assign to City" },
    { value: 2, label: "Assign to Guest" }
  ];

  const handleGetSendType = async () => {
    const resp = await stockOutSendType({ method: 4 });
    let newSendTypeList = [{ value: 0, label: "Select Send Type" }];
    if (resp.status == 1) {
      resp?.data?.map((res) => {
        newSendTypeList.push({ value: res.s_type_id, label: res.type_name });
      });
      setSendTypeList(newSendTypeList);
    }
  };

  useEffect(async () => {
    let res = await fetchallcitylist();
    let newCityList = [{ value: 0, label: "Select City" }];
    res?.map((res) => {
      newCityList.push({ value: res.city_id, label: res.city_name });
    });
    setClityList(newCityList);
  }, []);

  useEffect(() => {
    handleGetSendType();
  }, []);

  const handleAssignProduct = async () => {
    if (
      (assignData.p_qty !== "" && assignData.s_type_id !== "" && assignData.date !== "") ||
      (assignData.assign_to === 1 &&
        assignData?.city_id !== "" &&
        assignData?.city_id !== "" &&
        assignData.q_c_name !== "") ||
      (assignData.assign_to === 2 && assignData?.assign_name !== "")
    ) {
      setLoader(true);
      const formData = new FormData();

      formData.append("u_id", realUser?.u_id);
      formData.append("p_user_id", user?.u_type == 2 ? user?.p_user_id : realUser?.u_id);
      formData.append("p_qty", assignData.p_qty);
      formData.append("s_type_id", assignData.s_type_id);
      formData.append("assign_to", assignData.assign_to);
      formData.append(
        "city_id",
        user.u_type !== 0 && assignData.assign_to === 2 ? user?.city_id : assignData.city_id || ""
      );
      formData.append("q_c_name", assignData.q_c_name || "");
      formData.append("courier_price", assignData.courier_price || "");
      formData.append("p_id", rowData.p_id);
      formData.append("p_name", assignData.p_name);
      formData.append("p_city_price", assignData.p_city_price);
      formData.append(
        "city_name",
        modalType === "Edit" ? rowData?.city_name : assignData.city_name
      );
      formData.append("assign_name", assignData.assign_name || "");
      formData.append("u_name", realUser?.name);
      const formattedDate =
        assignData.date !== "DD-MM-YYYY"
          ? moment(assignData.date).format("DD-MM-YYYY")
          : assignData.date;

      formData.append("date", formattedDate);
      if (assignData.receipt) {
        formData.append("receipt", assignData.receipt); // optional
      }
      if (assignData.dispatch_form) {
        formData.append("dispatch_form", assignData.dispatch_form); // optional
      }

      if (modalType === "Edit") {
        formData.append("old_qty", rowData.qty);
        formData.append("s_h_id", rowData.s_h_id);
        setIsLoading(true);
        let resp = await updateStockInDataApi(formData);
        setIsLoading(false);
        if (resp.status != 0) {
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
          resetFormData();
          toggleAssignProductModal();
          handleGetProducts();
        } else {
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
        }
      } else {
        setIsLoading(true);

        let resp = await assignStockToCityData(
          formData
          //   {
          //   ...assignData,
          //   date:
          //     assignData.date !== "DD-MM-YYYY"
          //       ? moment(assignData.date).format("DD-MM-YYYY")
          //       : assignData.date
          // }
        );
        setIsLoading(false);
        if (resp.status != 0) {
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
          resetFormData();
          toggleAssignProductModal();
          handleGetProducts();
        } else {
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
        }
      }
      setLoader(false);
    } else {
      let notify = notification({
        type: "error",
        message: "Please Fill All Fields data"
      });
      notify();
    }
  };

  return (
    <Modal
      open={assignProductModal}
      onClose={() => toggleAssignProductModal()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          style={{ marginBottom: "5px", textAlign: "center" }}
        >
          {/* Assign Product */}
          {rowData.p_name}
        </Typography>
        <hr />
        <Stack style={{ marginBottom: "15px" }}>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Stack spacing={10} style={{ marginTop: "15px" }}>
                {/* <label style={{ marginBottom: "10px" }}>Select City</label> */}
                <Select
                  value={
                    assignOptions &&
                    assignOptions.map((option) => {
                      if (option.value == assignData.assign_to) {
                        return { value: option.value, label: option.label };
                      }
                    })
                  }
                  isDisabled={modalType === "Edit"}
                  onChange={async (e) => {
                    setAssignData({
                      ...assignData,
                      assign_to: e.value,
                      city_id: e.value === 2 ? 0 : ""
                    });
                  }}
                  options={
                    user.u_type !== 0 || (user?.u_type === 2 && user?.p_user_id === 1)
                      ? assignOptions[1]
                      : assignOptions
                  }
                />
              </Stack>
            </Grid>
            <Grid item xs={6}>
              <Stack spacing={3} style={{ marginBottom: "15px", marginTop: "15px" }}>
                {/* <label style={{ marginBottom: '10px' }}>Join Date</label> */}
                <LocalizationProvider
                  dateAdapter={AdapterDateFns}
                  isDisabled
                  style={{ marginTop: "15px" }}
                >
                  <DatePicker
                    label="Date"
                    value={assignData.date}
                    inputFormat="dd/MM/yyyy"
                    onChange={(newDate) => {
                      setAssignData({
                        ...assignData,
                        date: newDate // ✅ keep Date object
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        sx={{
                          "& .MuiInputBase-root": { height: 40 },
                          "& .MuiInputLabel-root": { top: "-6px" }
                        }}
                      />
                    )}
                  />
                </LocalizationProvider>
              </Stack>
            </Grid>
            {assignData.assign_to === 1 ? (
              <Grid item xs={6}>
                <Stack spacing={10} style={{ marginBottom: "15px" }}>
                  {/* <label style={{ marginBottom: "10px" }}>Select City</label> */}
                  <Select
                    value={
                      cityList &&
                      cityList.map((option) => {
                        if (option.value == assignData.city_id) {
                          return { value: option.value, label: option.label };
                        }
                      })
                    }
                    isDisabled={modalType === "Edit"}
                    onChange={async (e) => {
                      setAssignData({
                        ...assignData,
                        city_id: e.value,
                        city_name: e.label
                      });
                    }}
                    options={cityList}
                  />
                </Stack>
              </Grid>
            ) : (
              <Grid item xs={6} style={{ marginBottom: "15px" }}>
                <TextField
                  fullWidth
                  autoComplete="off"
                  type="text"
                  label="Guest Name"
                  name="assign_name"
                  size="small"
                  required
                  placeholder="Enter Guest Name"
                  onChange={(e) => {
                    setAssignData({
                      ...assignData,
                      assign_name: e.target.value
                    });
                  }}
                  value={assignData?.assign_name}
                />
              </Grid>
            )}
            <Grid item xs={6} style={{ marginBottom: "15px" }}>
              <TextField
                fullWidth
                autoComplete="off"
                type="number"
                label="Quantity"
                name="p_qty"
                required
                size="small"
                placeholder="Enter Quantity"
                onChange={(e) => {
                  setAssignData({
                    ...assignData,
                    p_qty: e.target.value
                  });
                }}
                value={assignData?.p_qty}
              />
            </Grid>
            {assignData.assign_to === 1 ? (
              <>
                <Grid item xs={6}>
                  <Stack spacing={10} style={{ marginBottom: "15px" }}>
                    <Select
                      value={
                        sendTypeList &&
                        sendTypeList.map((option) => {
                          if (option.value == assignData.s_type_id) {
                            return { value: option.value, label: option.label };
                          }
                        })
                      }
                      onChange={async (e) => {
                        setAssignData({
                          ...assignData,
                          s_type_id: e.value
                        });
                      }}
                      options={sendTypeList}
                    />
                  </Stack>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    autoComplete="off"
                    type="text"
                    label="QC Name"
                    name="q_c_name"
                    required
                    size="small"
                    placeholder="Enter QC Name"
                    onChange={(e) => {
                      setAssignData({
                        ...assignData,
                        q_c_name: e.target.value
                      });
                    }}
                    value={assignData?.q_c_name}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    autoComplete="off"
                    type="number"
                    label="Courier Price"
                    name="courier_price"
                    size="small"
                    placeholder="Enter QC Price"
                    onChange={(e) => {
                      setAssignData({
                        ...assignData,
                        courier_price: e.target.value
                      });
                    }}
                    value={assignData?.courier_price}
                  />
                </Grid>{" "}
                <Grid item xs={4}>
                  <label>Receipt</label>
                  <br />
                  {assignData?.receipt && (
                    <p style={{ margin: "5px 0", fontSize: "14px", fontWeight: 500 }}>
                      {assignData.receipt.name}
                    </p>
                  )}

                  <Stack direction="row" alignItems={"center"} spacing={2}>
                    <Button
                      variant="contained"
                      component="label"
                      sx={{ height: 40 }}
                      // style={{ marginTop: "10px" }}
                    >
                      Click To Upload File
                      <input
                        id="file"
                        name="file"
                        type="file"
                        hidden
                        accept=".jpeg,.jpg,.png,.gif,.bmp"
                        onChange={(event) => {
                          setAssignData({
                            ...assignData,
                            receipt: event.currentTarget.files[0]
                          });
                        }}
                        className="form-control"
                      />
                    </Button>
                  </Stack>
                </Grid>
                <Grid item xs={4}>
                  <label>Dispatch Form</label>
                  <br />
                  {assignData?.dispatch_form && (
                    <p style={{ margin: "5px 0", fontSize: "14px", fontWeight: 500 }}>
                      {assignData.dispatch_form.name}
                    </p>
                  )}

                  <Stack direction="row" alignItems={"center"} spacing={2}>
                    <Button
                      variant="contained"
                      component="label"
                      sx={{ height: 40 }}
                      // style={{ marginTop: "10px" }}
                    >
                      Click To Upload File
                      <input
                        id="file"
                        name="file"
                        type="file"
                        hidden
                        accept=".jpeg,.jpg,.png,.gif,.bmp"
                        onChange={(event) => {
                          setAssignData({
                            ...assignData,
                            dispatch_form: event.currentTarget.files[0]
                          });
                        }}
                        className="form-control"
                      />
                    </Button>
                  </Stack>
                </Grid>
              </>
            ) : (
              ""
            )}
            {assignData.assign_to === 2 && user?.u_type === 1 ? (
              <Grid item xs={6} style={{ marginBottom: "15px" }}>
                <TextField
                  fullWidth
                  autoComplete="off"
                  type="number"
                  label="Price"
                  name="p_city_price"
                  aria-readonly
                  required
                  size="small"
                  value={rowData?.p_city_price}
                />
              </Grid>
            ) : (
              ""
            )}

            <Grid
              item
              sm={12}
              xs={12}
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "center"
              }}
            >
              <Button
                variant="outlined"
                onClick={() => toggleAssignProductModal()}
                style={{ marginTop: "15px", marginRight: "15px" }}
              >
                Close
              </Button>
              <Button
                variant="contained"
                style={{ marginTop: "15px" }}
                onClick={() => !loader && handleAssignProduct()}
                disabled={isLoading}
                startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </Stack>
      </Box>
    </Modal>
  );
}
